module.exports = "<!-- header -->\r\n<header><h1>Login</h1></header>\r\n<!-- Form -->\r\n<form (submit)=\"login($event)\">\r\n  <dx-form \r\n    id=\"formLogin\"\r\n    [(formData)]=\"loginForm\"\r\n    [(items)]=\"itemsForm\"\r\n    validationGroup=\"valFormLogin\" \r\n    labelLocation=\"top\" \r\n    showValidationSummary=\"true\">\r\n  </dx-form>\r\n  <div>\r\n    <dx-button text=\"Login\" validationGroup=\"valFormLogin\" [useSubmitBehavior]=\"true\" (onClick)=\"login($event)\"></dx-button>\r\n  </div>\r\n</form>"


//////////////////
// WEBPACK FOOTER
// ./src/app/login/login.component.html
// module id = ./src/app/login/login.component.html
// module chunks = main